import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';


export default function Table({
    columns,
    rows,
}) {
    useEffect(() => {
    }, [rows, columns]);

    return (
        <StyledTable>
            <TableHeader>
                {
                    columns?.map((item, index) => (
                        <TableHeaderItem key={index}> {item} </TableHeaderItem>
                    ))
                }
            </TableHeader>
            <TableBody>
                {
                    rows && rows?.map((el, index) => (
                        // `el` é um objeto de células montado pelo chamador e nem
                        // sempre carrega `id` — usar `el.id` gerava key undefined
                        // em todas as linhas (aviso do React e reconciliação
                        // instável ao paginar).
                        <TableBodyRow key={el.id ?? index}>
                            {
                                Object.entries(el).map(([key, item], idx) => (
                                    <TableBodyItem key={idx}>
                                        <ColumnHeader>{columns[idx]}</ColumnHeader>
                                        <ContainerText color={typeof item === 'string' && (item === 'Ativa' || item === 'Desativada') ? item : null}>
                                            {typeof item === 'object' ? item : item}
                                        </ContainerText>
                                    </TableBodyItem>
                                ))
                            }
                        </TableBodyRow>
                    ))
                }
            </TableBody>
        </StyledTable>
    );
}

const StyledTable = styled.div`
  border-radius: 6px;
  overflow: hidden;
  background: ${colors.neutralLight};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  margin-top: 24px;
  border: 1px solid ${colors.neutralDark};

  @media screen and (max-width: ${breakpoints.lg}) {
    border: 1px solid transparent;
  }
`;

const TableHeader = styled(Row)`
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid ${colors.neutralDark};
  text-transform: capitalize;

  @media screen and (max-width: ${breakpoints.lg}) {
    display: none;
  }
`;

const TableHeaderItem = styled.div`
  text-align: left;
  width: 100%;
  padding: 0 12px;
  min-width: 140px;
  color: ${colors.secondaryDark};
  font-size: 14px;
`;

const TableBody = styled(Column)`
  background: ${colors.neutralLight};
`;

const TableBodyRow = styled(Row)`
  width: 100%;
  justify-content: space-between;
  background: ${colors.neutralLight};
  /* border-bottom: 1px solid ${colors.neutralDark}; */
  padding: 16px 24px;

  &:nth-child(odd) {
    background: ${colors.neutral};
  }
  
  @media screen and (max-width: ${breakpoints.lg}) {
      flex-direction: column;
      border: 1px solid #ccc;
      background: ${colors.neutralLight};
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
      padding: 16px;
      margin-bottom: 6px;
      
      &:nth-child(odd) {
        background: ${colors.neutralLight};
      }   
  }
`;

const TableBodyItem = styled(Row)`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 12px;

  @media screen and (min-width: ${breakpoints.lg}) {
    margin-bottom: 0;
    padding: 0 12px;
  }
`;

const ColumnHeader = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: ${colors.nightDark};

  @media screen and (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;


const ContainerText = styled(Row)`
  font-size: 14px;
  color: ${colors.nightDark};

  ${({ color }) =>
        color === 'Ativa' &&
        css`
      background: ${colors.successLight};
      color: ${colors.successDark};
      font-weight: 500;
      padding: 4px 10px;
      border-radius: 8px;
      display: inline-block;
    `};

  ${({ color }) =>
        color === 'Desativada' &&
        css`
      background: ${colors.dangerLight};
      color: ${colors.dangerDark};
      font-weight: 500;
      padding: 4px 10px;
      border-radius: 8px;
      display: inline-block;
    `};
`;
